export default "__VITE_ASSET__J63DVM5R__"